export default __webpack_public_path__ + "static/facebookMessangerLogo-ff23def5b8d8b080507995d169521384.svg";